import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-reveal';
import { Tab, Divider, Icon, Statistic, Comment, Input, Button, Form, TextArea, Select, Loader, Dropdown, Checkbox, Label, Menu, Dimmer} from 'semantic-ui-react';
import QRCode from "react-qr-code";
import { Rating } from 'semantic-ui-react'
import GConf from '../../../AssetsM/generalConf';
import axios from 'axios';
import { toast } from 'react-toastify';
import SKLT from '../../../AssetsM/Cards/usedSlk';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer , useMapEvents, useMap} from 'react-leaflet';
import AvatarGroup from '@atlaskit/avatar-group';
import FrameForPrint from '../../../AssetsM/Cards/frameForPrint';
import usePrintFunction from '../../../AssetsM/Hooks/printFunction';
import TunMap from '../../../AssetsM/tunMap';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import FullCalendar from '@fullcalendar/react' // must go before plugins
import timeGridPlugin from '@fullcalendar/timegrid';
import { useTranslation, Trans } from 'react-i18next';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'


const EditProfile = ({generalData, setGeneralData, UpdateGeneralDataFunc, delegList,GetDelegList,loaderState}) =>{
    const { t, i18n } = useTranslation();
    
      function GenerateGenreListe() {
        return GConf.ProfileGenre.map(item => ({
            key: item.id.toString(),
            value: item.value,
            text: item.name,
            image: { src: `https://cdn.abyedh.com/images/Search/Land_icons/${item.imgSrc}.gif`, avatar: true }
        }));
      }
      useEffect(() => {
         
        GetDelegList(generalData.Gouv)
        setGeneralData({...generalData, Gouv: generalData.Gouv })
        setGeneralData({...generalData, Deleg: generalData.Deleg })
        setGeneralData({...generalData, Genre: generalData.Genre })
      },[])

    return ( <>
        <h3 className='text-secondary'><span className='bi bi-journal-album'></span> {t('communUsed.profilePage.generalEditData.title')}</h3> 
         
        <h5 className='mb-1'>  {t('communUsed.profilePage.generalEditData.name')}</h5>
        <Input icon='user' iconPosition='left' placeholder={t('communUsed.profilePage.generalEditData.name')} value={generalData.Name} onChange={(e) => setGeneralData({...generalData, Name: e.target.value })} fluid />
        
        <h5 className='mb-1'> {t('communUsed.profilePage.generalEditData.phone')} </h5>
        <Input icon='phone' iconPosition='left' placeholder={t('communUsed.profilePage.generalEditData.phone')} value={generalData.Phone} onChange={(e) => setGeneralData({...generalData, Phone: e.target.value })} fluid />
        <h5 className='mb-1'> {t('communUsed.profilePage.generalEditData.location')} </h5>
        <div className='mb-2'>
            <Select placeholder={t('communUsed.profilePage.generalEditData.gouv')} fluid className='mb-2' options={TunMap.Gouv} value={generalData.Gouv} onChange={(e, { value }) => GetDelegList(value)} />
            <Select placeholder={t('communUsed.profilePage.generalEditData.deleg')} fluid value={generalData.Deleg} options={delegList} onChange={(e, { value }) => setGeneralData({...generalData, Deleg: value })} />
        </div>
        <h5 className='mb-1'> {t('communUsed.profilePage.generalEditData.adress')}</h5>
        <Form>
             <TextArea  rows="3" placeholder={t('communUsed.profilePage.generalEditData.adress')} className='w-100'  value={generalData.Adress} onChange={(e) => setGeneralData({...generalData, Adress: e.target.value })} />
        </Form>
        <h5 className='mb-1'>{t('communUsed.profilePage.generalEditData.genre')}</h5>
        <Dropdown
            search
            selection
            fluid
            wrapSelection={false}
            options={GenerateGenreListe()}
            placeholder={t('communUsed.profilePage.generalEditData.genre')}
            className='mb-1'
            onChange={(e, { value }) => setGeneralData({...generalData, Genre: value })}
            value={generalData.Genre}
        />
        <br />
        <div className='text-end'>
            <Button  className='rounded-pill bg-system-btn' onClick={() => UpdateGeneralDataFunc()} ><Icon name='save' /> {t('communUsed.profilePage.generalEditData.editBtn')} <Loader active={loaderState} inverted  inline size='tiny' className='ms-2'/></Button>
        </div>

    </> );
}
const MapEventsHandler = ({ onLocationSelected }) => {
    useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng;
        onLocationSelected({ lat, lng });
      },
    });
  
    return null;
}
const Horaire = ({alwaysState, setAlwaysState, timming, setTimming, setPauseDay , SetTimmingData,UpdateTimmingData, setSelectedUpdateDay, selectedUpdateDay}) =>{
    const { t, i18n } = useTranslation();
    
    let [addInput, setAddInput] = useState(false)
    let [dateDataToChange, setDateDataToChange] = useState({pauseDay: false, matinStart:'08:00', matinFinsh:'12:00', soirStart:'14:00', soirFinsh:'18:00'})
    const weekDays = [
        { key: 'af', value: 'Lun', text: 'الانثنين' },
        { key: 'ax', value: 'Mar', text: 'الثلاثاء' },
        { key: 'al', value: 'Mer', text: 'الاربعاء' },
        { key: 'dz', value: 'Jeu', text: 'الخميس' },
        { key: 'as', value: 'Vend', text: 'الجمعة' },
        { key: 'ad', value: 'Sam', text: 'السبت' },
        { key: 'ao', value: 'Dim', text: 'الاحد' },
    ]
    const ArabificationDate = (dateName) =>{
        switch (dateName) {
            // case 'Lun' : return 'الإثــنين' 
            // break;
            // case 'Mar' : return 'الثلاثــاء'
            // break;
            // case 'Mer' : return 'الإربــعاء'
            // break;
            // case 'Jeu' : return 'الخميس'
            // break;
            // case 'Vend' : return 'الجـمعة'
            // break;
            // case 'Sam' : return 'الســبت'
            // break;
            // case 'Dim' : return 'الأحـــد'
            // break;

            case 'Lun' : return 'Lundi' 
            break;
            case 'Mar' : return 'Mardi'
            break;
            case 'Mer' : return 'Mercredi'
            break;
            case 'Jeu' : return 'Jeudi'
            break;
            case 'Vend' : return 'Vendredi'
            break;
            case 'Sam' : return 'Samedi'
            break;
            case 'Dim' : return 'Dimmanche'
            break;

            default:
                break;
        }
    }
    const DayHoraire = (props) =>{
        return(<>
                <div className={`ps-2 row  mb-1 ${props.data.dayOff ? 'text-danger':''}`}>
                    <div  className='col-3 col-lg-3 m-0 p-1'>
                        <b>{ArabificationDate(props.data.day)}</b>
                    </div>
                    <div  className='col-4 col-lg-4  m-0 p-1'>
                        <small>{props.data.matin.start} - {props.data.matin.end}</small>
                    </div>
                    <div  className='col-4 col-lg-4  m-0 p-1'>
                        <small>{props.data.soir.start} - {props.data.soir.end}</small>
                    </div>
                    <div className='col-1 m-0 p-1'>
                        <span className='bi bi-pencil-square bi-xsm text-secondary' onClick={() => OpenEditTime(props.data.day)}></span>
                    </div>
                </div>
        </>)
    }
    const OpenEditTime = (value) =>{
        setSelectedUpdateDay(value)
        setAddInput(true)
    }
    const UpdateTimingFunc = () =>{
        const targetIndex = timming.findIndex(element => element.day === selectedUpdateDay)
        let copyOfHoraire = timming
        copyOfHoraire[targetIndex] = {day: selectedUpdateDay , dayOff: dateDataToChange.pauseDay , matin:{start: dateDataToChange.matinStart ,end: dateDataToChange.matinFinsh},soir:{start: dateDataToChange.soirStart,end: dateDataToChange.soirFinsh}}
        setTimming(copyOfHoraire)
        //SetTimmingData()
        setAddInput(!addInput)
    }
    return(<>
        
        <div className=' ' >
            <h3 className='text-start text-secondary ' > <span className='bi bi-calendar-week-fill'></span>  modifier l'horaire </h3>
            <div className='row'>
                <div className='col-12 col-lg-12'>
                    <div className=' '>
                        <div className='row'>
                            <div className='col-10 col-lg-9 align-self-center'> 
                                <h5 className='mb-0 text-success'> Toujours ouvert </h5>  
                                <small>   En activant cette option, il apparaîtra comme toujours ouvert   </small>
                            </div>
                            <div className='col-2 col-lg-3  align-self-center '> 
                                <div className="form-check form-switch float-end">
                                    <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setAlwaysState(!alwaysState)}  checked={alwaysState} />
                                </div>
                            </div>
                        </div>
                        <Divider />
                        {addInput ? 
                                <div className='d-block card-body border-div  '>
                                    
                                    <h5 className='mt-0'>  Est-ce que le   {ArabificationDate(selectedUpdateDay)}  est un jour de repos ?  </h5>
                                    <Select options={[ { key: 'af', value: false, text: 'Non' }, { key: 'ax', value: true, text: 'Oui' }]} onChange={(e, {value}) => setDateDataToChange({... dateDataToChange, pauseDay : value})} className='mb-3'/>
                                    <div className='row mb-3 '>
                                        <div className='col-6'><Input  type='time' size='mini'  value={dateDataToChange.matinStart}  fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, matinStart : e.target.value})} /></div>
                                        <div className='col-6'><Input  type='time' size="mini"  value={dateDataToChange.matinFinsh} fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, matinFinsh : e.target.value})}/></div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-6'><Input  type='time' size='mini'  value={dateDataToChange.soirStart}   fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, soirStart : e.target.value})} /></div>
                                        <div className='col-6'><Input  type='time' size="mini"  value={dateDataToChange.soirFinsh}  fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, soirFinsh : e.target.value})}/></div>
                                    </div>
                                    <Button size='mini'     className='rounded-pill  mb-2  font-droid' onClick={() => UpdateTimingFunc()} fluid  >   <Icon name='time' />   Modifier l'horaire du jour  {ArabificationDate(selectedUpdateDay)}  </Button>
                                    <Button size='mini'     className='rounded-pill  bg-danger text-white  font-droid' onClick={() => setAddInput(!addInput)} fluid  >   <Icon name='eye' /> afficher l'horaire  </Button>
                                    {/* <div className='text-start'><span className='bi bi-x-circle-fill  text-danger text-secondary mb-2' onClick={() => setAddInput(!addInput)}></span></div> */}
                                    
                                </div>

                                

                        :
                                <>
                                    <div className='row text-secondary mb-2'>
                                        <div  className='col-4 col-lg-4'> <b>Jour </b> </div>
                                        <div  className='col-4 col-lg-4'> <small>Matin</small> </div>
                                        <div  className='col-4 col-lg-4'> <small>Soir</small> </div>
                                    </div>
                                    
                                    {
                                        timming.map( (data,index) => <DayHoraire key={index} data={data} />)
                                    }

                                    <div className='text-end mt-4'>
                                        <Button       className='rounded-pill  text-white  font-droid'  style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}} onClick={() => UpdateTimmingData()}    >  <Icon name='time' />  modifier l'horaire   </Button>
                                    </div>
                                </>
                        }
                        
                    </div>
                </div>
                <div className='col-12 col-lg-5 d-none'>
                    <div className='card card-body border-div'>
                        <h5>قم باختيار يوم لتعديل الوقت </h5>
                        <Select options={weekDays} onChange={(e, { value }) => setSelectedUpdateDay(value)} className='mb-3'/>
                        <div className='row mb-3 '>
                            <div className='col-6'><Input  type='time' size='mini'  value={timming.find(obj => obj.day === selectedUpdateDay).matin.start}  fluid className='mb-1 w-100'  onChange={(e) => SetTimmingData(selectedUpdateDay,'matin','start',e.target.value)} /></div>
                            <div className='col-6'><Input  type='time' size="mini"  value={timming.find(obj => obj.day === selectedUpdateDay).matin.end} fluid className='mb-1 w-100'  onChange={(e) => SetTimmingData(selectedUpdateDay,'matin','end',e.target.value)}/></div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-6'><Input  type='time' size='mini'  value={timming.find(obj => obj.day === selectedUpdateDay).soir.start}   fluid className='mb-1 w-100'  onChange={(e) => SetTimmingData(selectedUpdateDay,'soir','start',e.target.value)} /></div>
                            <div className='col-6'><Input  type='time' size="mini"  value={timming.find(obj => obj.day === selectedUpdateDay).soir.end}  fluid className='mb-1 w-100'  onChange={(e) => SetTimmingData(selectedUpdateDay,'soir','end',e.target.value)}/></div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-2 text-end'>
                                <div className="form-check form-switch">
                                    <input className="form-check-input form-check-input-lg" type="checkbox" checked={timming.find(obj => obj.day === selectedUpdateDay).dayOff}   onChange={() => setPauseDay(selectedUpdateDay,selectedUpdateDay.dayOff)}   />
                                </div>
                            </div>
                            <div className='col-10'>يوم راحة ؟ </div>
                        </div>
                        
                        <Button size='mini'     className='rounded-pill    font-droid' onClick={() => UpdateTimmingData()} fluid  >   <Icon name='time' /> تعديل  </Button>
                    </div>
                </div>
            </div>
            
        </div>
    </>)
}
const Location = ({position,handleLocationSelected,GetMyLocation, loaderState, setPosition, generalData, UpdatePositionFunc}) =>{
    const { t, i18n } = useTranslation();
    
    function RecenterMap({ position }) {
            const map = useMap();
          
            useEffect(() => {
              if (position?.Lat && position?.Lng) {
                map.setView([position.Lat, position.Lng]);
              }
            }, [position, map]);
          
            return null;
    }
    useEffect(() => {
        console.log(generalData.Lng != '')
        if (generalData.Lng != '') {setPosition({Lat: parseFloat(generalData.Lat), Lng: parseFloat(generalData.Lng)})}
        
    }, [])
   

    return(<>
         
        <div className='mb-3'  >
                <h3 className='text-start text-secondary '  > <span className='bi bi-geo-alt-fill'></span>   Modifier la position geographique </h3>
                <div className='row mb-3'>
                        <div className='col-6 align-self-center text-start'> <small className='mb-3'>  Cliquez sur le bouton pour définir votre position actuelle par défaut. </small></div>
                        <div className='col-6 align-self-center text-end'><Button icon='map pin' className='rounded-circle' onClick={() => GetMyLocation()}></Button></div>
                </div> 
                
               
                <MapContainer center={[position.Lat,position.Lng]} zoom={9} scrollWheelZoom={false} className="map-height-lg border-div">
                    <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <MapEventsHandler onLocationSelected={handleLocationSelected} />
                    <RecenterMap position={position} />
                    <Marker position={[position.Lat,position.Lng]}>
                        <Popup> </Popup>
                    </Marker>
                </MapContainer> 
                {/* <div className='col-4 text-start'> 
                        <Button  className='rounded-pill bg-system-btn' disabled={CheckPositions()} size='mini' onClick={ () => UpdatePositionFunc()} ><Icon name='save' /> Modifier Position <Loader inverted active={loaderState}  inline size='tiny' className='ms-2'/></Button>
                </div> */}
                <div className='text-end mt-4'>
                    <Button  className='rounded-pill text-white' style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}}   onClick={() => UpdatePositionFunc()} ><Icon name='save' /> Modifier ma position  <Loader active={loaderState} inverted  inline size='tiny' className='ms-2'/></Button>
                </div>
                {/* <LocationPicker    />*/}
        </div>
    </>)
}
const ProfilePictureCard = () =>{
        const [profileData, setProfileData] = useState([])
    
        /*Images */
        const [imagesListe, setImagesListe] = useState([])
        const [uploadImage, setUploadImages] = useState()
        const [formaDataArr, setFormDataArr] = useState()
        const [displayedImage, setDisplayedImage] = useState()
        const [todisplayedImage, setToDisplayedImage] = useState([])
        const [crop, setCrop] = useState({ x: 0, y: 0 })
        const [zoom, setZoom] = useState(1)
    
     
        /* Others */
        const [loading , setLoading] = useState(false)
       
        const [loaderState, setLS] = useState(false)

        useEffect(() => {                 
                axios.post(`https://api.abyedh.com/api/systems/app/profile`, {
                     PID: localStorage.getItem('PID'),
                     SystemTag : GConf.systemTag
                 })
                .then(function (response) {  
                    setImagesListe(response.data.general[0].ProfilePhoto)
                    setLoading(true)
        
                }).catch((error) => {
                    if(error.request) {
                      toast.error(<><div><h5>Probleme de Connextion</h5> Esseyeé de connecter plus tard</div></>, GConf.TostInternetGonf) 
                      setProfileData([])
                      //setLoading(true)
                    }
                });
        }, [])

        const handleFileSelect = async (event) => {
        const files = event.target.files;
        const formData = new FormData();
        const resizedImages = [];
    
        const resizeImage = (file, maxWidth, maxHeight) => {
            return new Promise((resolve) => {
                const img = new Image();
                const reader = new FileReader();
    
                reader.onload = (e) => {
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = maxWidth;
                        canvas.height = maxHeight;
                        const ctx = canvas.getContext("2d");
    
                        // Draw the image centered & scaled to fill 500x500
                        const ratio = Math.min(img.width / maxWidth, img.height / maxHeight);
                        const newWidth = img.width / ratio;
                        const newHeight = img.height / ratio;
                        const offsetX = (maxWidth - newWidth) / 2;
                        const offsetY = (maxHeight - newHeight) / 2;
    
                        ctx.fillStyle = "#ffffff"; // Fill background if needed
                        ctx.fillRect(0, 0, maxWidth, maxHeight);
                        ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);
    
                        canvas.toBlob((blob) => {
                            resolve(blob);
                        }, "image/jpeg", 0.9);
                    };
                    img.src = e.target.result;
                };
    
                reader.readAsDataURL(file);
            });
        };
    
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const resizedBlob = await resizeImage(file, 500, 500);
            const filename = `${GConf.systemTag}_${GConf.PID}_${i}.jpg`;
            formData.append('Images', resizedBlob, filename);
        }
    
        formData.append("PID", GConf.PID);
        formData.append("SystemTag", GConf.systemTag);
    
        const uploadedImages = Array.from(files);
        setToDisplayedImage(uploadedImages);
        setFormDataArr(formData);
    };
    const UpdateImageFuncMultiple = (formData) =>{
        console.log(todisplayedImage.length)
        if (todisplayedImage.length == 0) {toast.error("Il Faut 5 Images !", GConf.TostErrorGonf) } 
        else if (todisplayedImage.length > 5) {toast.error("cinque Images Seulemment Sont autoriseé !", GConf.TostErrorGonf) } 
        else {
            axios.post(`https://api.abyedh.com/api/application/app/profile/update/profile-pic`, formData)
            .then(response => toast.success("Images Modifieé !", GConf.TostSuucessGonf))
            .catch(error => console.log(error));
        }
        
    }
    const RemoveImageFunc = (imgName) => {
        console.log(imgName.slice(0, -4))
        axios.post(`https://api.abyedh.com/api/application/app/profile/images/deletefile`, {
            fileName : imgName,
            SystemTag : GConf.systemTag,
            PID : GConf.PID,
        }).then(function (response) {
             
            if(response.data.affectedRows) {
                toast.success("Image Supprimeé !", GConf.TostSuucessGonf)
                setLS(false)
                window.location.reload()
            }
            else{
                toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                setLS(false)
            }
        })
    }

        const PasDeResultat = () =>{
            return(<>
                <div className='text-center'>
                         
                        <label onChange={handleFileSelect} htmlFor="formId"   className='text-info' role="button">
                                <Input type='file' hidden name="Images" id="formId" multiple />
                                <span className='bi bi-camera text-danger' style={{fontSize : '70px'}}></span>
                                <h5 className='text-secondary'> cliquer pour ajouter une photo de profile  </h5>
                        </label>
                        
                </div>
            </>)
        }
        return(<>
            {!imagesListe ?
                <>
                    {/* <UploadImageCard title='Image de Profile' tag='profile' />  */}
                    <br />
                    <div className='row'>
                            {todisplayedImage.length != '0' ? 
                            <>
                                 
                                <div className='max-height-image mb-2 text-center'>
                                    <img src={URL.createObjectURL(todisplayedImage[0])} className='border rounded-circle shadow float-center mb-3' width='200px' height='200px'  />
                                </div>
                                {/* <div
                                className='border-div justify-content-center mb-3'
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '200px',
                                    
                                }}
                                >
                                    <Cropper
                                        image={URL.createObjectURL(todisplayedImage[0])}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={1/1}
                                        cropShape={'round'}
                                        //onCropComplete={(croppedArea, croppedAreaPixels) => OnCropComplete(croppedArea, croppedAreaPixels)}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                    />
                                </div> */}
                                <br />
                                <div className='row  '>
                                    <div className='col-6 align-self-center'>
                                         <Button className='rounded-pill bg-danger text-white' fluid onClick={() => {setToDisplayedImage(todisplayedImage.filter((item, tindex) => tindex !== 0))}}> Annuleé </Button>
                                    </div>
                                    <div className='col-6 align-self-center text-end'>
                                            <Button   className='rounded-pill bg-system-btn'  onClick={() => UpdateImageFuncMultiple(formaDataArr)} ><Icon name='save' /> Enregistreé <Loader inverted active={loaderState} inline size='tiny' className='text-danger'/></Button>
                                    </div>
                                </div>
                                
                                
                            </>   
                            : 
                            <PasDeResultat />}
                    </div>
                </>
                :
                <>
                    <div className='text-center'>
                        <img src={`https://cdn.abyedh.com/images/Directory/${imagesListe}`} className='img-responside rounded-circle shadow mb-3' width='200px' height='200px' />
                        <div className='card card-body mt-3 border-div'>
                            <h5 className='text-start text-secondary'>Modifier L'image ? </h5>
                            <div className='text-start mb-2'>
                                <small className='text-secondary'>Pour pouvoir éditer l'image, vous devez d'abord <br /> supprimer l'ancienne image.</small>
                            </div>
                            <Button className='bg-danger text-white' fluid onClick={() => RemoveImageFunc(imagesListe)}>Supprime ?? </Button>
                        </div>
                        
                    </div>
                </>  
            }
                
        </>)
}
const ImageCard = ({setImagesListe,setLoading,loadingState,SavePhotos,disabledSaveBtn,loaderState,imagesListe,OpenDeleteModal, onFileUpload, imageLink}) =>{
         useEffect(() => {
                 axios.post(`https://api.abyedh.com/api/systems/app/profile`, {
                     PID: localStorage.getItem('PID'),
                     SystemTag : GConf.systemTag
                 })
                 .then(function (response) {
                      
                     setImagesListe(response.data.images)
                     setLoading(true)
         
                 }).catch((error) => {
                     if(error.request) {
                       toast.error(<><div><h5>Probleme de Connextion</h5> Esseyeé de connecter plus tard</div></>, GConf.TostInternetGonf) 
                       
                     }
                 });
             }, [])
        return(<>
        <div className=" ">
                <h3 className='text-start text-secondary '  > <span className='bi bi-images'></span>   Ajouter des Images </h3>
                {loadingState || imageLink != '' ? <></> : <div className='border p-2 text-center border-div shadow-sm'>
                    <label onChange={onFileUpload} htmlFor="formId"   className='text-info' role="button">
                            <Input type='file' hidden name="Images" id="formId"  />
                            <span className='bi bi-camera ' style={{fontSize : '40px'}}></span>
                    </label>
                </div>}
                {loadingState ?  <div className='text-center'><span className="spinner-border text-primary float-center"  ></span> </div>: <></>}
                {imageLink == '' ? <></> : <img src={imageLink} className='border-div' width={'100%'} height='auto' />}
                {imageLink == '' ? <></> :  <div className='p-1'>
                    <Button className='rounded-pill' fluid onClick={() => SavePhotos()} disabled={disabledSaveBtn} size='small' icon style={{backgroundColor:'#216e55', color:'white'}} >   Enregistrer  <Icon name='save' />   <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                </div>}
            </div>
            <br />
             
             <h5>Listes des Images </h5>
            <div className='row'>
                {imagesListe.map((data,index) => 
                        <div className='col-4 p-1 m-0' onClick={() => OpenDeleteModal(data.Destination)}>
                            <img src={data.ImageLink} width='100%' height='100%' />
                        </div>
                )}  
            </div>
            

             
        </>)
}

function ProfilePage() {
    /*###############################[Const]################################# */
    const { t, i18n } = useTranslation();
    const [profileData, setProfileData] = useState([])
    const [generalData, setGeneralData] = useState({Name:'',Phone:'', Adress:'',Genre:'', Lat: '0.0', Lng:'0.2'})
    const [passwordData, setPasswordData] = useState({Identification:'',PasswordSalt:''})
    
    /*Horiare */
    const [horaireData, setHoraireData] = useState([])
    const [delegList ,setDelegList] = useState([])
    let [selectedUpdateDay , setSelectedUpdateDay] = useState('Lun')
    let [alwaysState , setAlwaysState] = useState(false)
    let [timming, setTimming] = useState([{day:"Lun",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Mar",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Mer",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Jeu",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Vend",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Sam",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}},{day:"Dim",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"18:00"}}])
    let [test , setTest] = useState(10)

    /*Images */
    const [imagesListe, setImagesListe] = useState([])
    const [loadingState, setLoadingState] = useState(false);
    const [profilePhotoData, setProfilePhotoData] = useState({});
    const [imageLink, setImageLink] = useState('')
    const [disabledSaveBtn, setDisabledBtn] = useState(false)
    const [toDeleteId, setToDeleteID] = useState('')
    const [openD, setOpenD] = useState(false)

    /*Position */
     const [myPosition, setMyPosition] = useState([36.17720,9.12337])
     let [position, setPosition] = useState({Lat: 36.83040, Lng: 10.13280})

    /* Others */
    const [loading , setLoading] = useState(false)
    const [saveBtnState, setSaveBtnState] = useState(false)
    const [loaderState, setLS] = useState(false)
    
    const [profilePicModal, setProfilePicModal] = useState(false)

    L.Icon.Default.mergeOptions(GConf.LeafleftIcon );
    const panes = [
        {
            menuItem: { key: 'edit', icon: 'edit outline', content: t('communUsed.profilePage.menuTabList.generalEdit') }, 
            render: () =><><Tab.Pane className='border-div' attached={false}><EditProfile generalData={generalData} setGeneralData={setGeneralData} UpdateGeneralDataFunc={UpdateGeneralDataFunc} delegList={delegList} GetDelegList={GetDelegList} loaderState={loaderState} /></Tab.Pane> <br/></>,
        },
        {
            menuItem: { key: 'comment', icon: 'time', content: t('communUsed.profilePage.menuTabList.horaireEdit') }, 
            render: () => <><Tab.Pane className='border-div' attached={false}><Horaire alwaysState={alwaysState} setAlwaysState={setAlwaysState} timming={timming} setTimming={setTimming} setPauseDay={setPauseDay} SetTimmingData={SetTimmingData} setSelectedUpdateDay={setSelectedUpdateDay} selectedUpdateDay={selectedUpdateDay} UpdateTimmingData={UpdateTimmingData} /></Tab.Pane><br /></>,
        },
        {
            menuItem: { key: 'position', icon: 'map', content: t('communUsed.profilePage.menuTabList.positionEdit') },
            render: () => <><Tab.Pane className='border-div' attached={false}><Location generalData={generalData} position={position} setPosition={setPosition} handleLocationSelected={handleLocationSelected} GetMyLocation={GetMyLocation} loaderState={loaderState} CheckPositions={CheckPositions} UpdatePositionFunc={UpdatePositionFunc} /></Tab.Pane><br /></>,
        },
        {
            menuItem: { key: 'images', icon: 'images', content: t('communUsed.profilePage.menuTabList.imagesEdit') },
            render: () => <><Tab.Pane className='border-div' attached={false}><ImageCard setImagesListe={setImagesListe} setLoading={setLoading} loadingState={loadingState} SavePhotos={SavePhotos} disabledSaveBtn={disabledSaveBtn} loaderState={loaderState} imagesListe={imagesListe} OpenDeleteModal={OpenDeleteModal} onFileUpload={onFileUpload} imageLink={imageLink}  /></Tab.Pane><br /></>,
        },
        {
            menuItem: { key: 'rate', icon: 'star', content: t('communUsed.profilePage.menuTabList.avisShow') }, 
            render: () => <><Tab.Pane className='border-div p-4' attached={false}>
                    <h3 className='text-start text-secondary mb-0'  > <span className='bi bi-star-half'></span>  Suivez les abonneé </h3>
                    <Tab menu={{ secondary: true, className: 'tab-right'}}  panes={RatingPanes} /></Tab.Pane><br /></>,
        }, 
        {
            menuItem: { key: 'print', icon: 'share alternate', content: 'Partager' }, 
            render: () => <><Tab.Pane className='border-div' attached={false}><PrintProfile /></Tab.Pane><br /></>,
        },{
            menuItem: { key: 'deconnxtion', icon: 'sign-out', content:  'Deconnextion '}, 
            render: () => <><Tab.Pane className='border-div' attached={false}><DeconnextionCard /></Tab.Pane><br /></>,
        },
    ]
    const RatingPanes = [
        {
          menuItem: { key: 'calendar', icon: 'star', content:  'Avis ', },  
          render: () => <RatingProfile />,
        },
        {
            menuItem: { key: 'users', icon: 'comment', content: 'Commentaire ' }, 
            render: () => <CommentsProfile />,
          },
      ] 
    /*###############################[UseEffect]################################# */
    useEffect(() => {
        
        GetPositionNow();
        axios.post(`${GConf.SharedApi}/profile`, {
            PID: GConf.PID,
            SystemTag : GConf.systemTag
        })
        .then(function (response) {
            setGeneralData(response.data.general[0])
            setProfileData(response.data)
            setPasswordData(response.data.password[0]) 
            setImagesListe(response.data.images)

            if (response.data.horaire[0]) { setAlwaysState(response.data.horaire[0].ALL_Time) } else { }
            if (response.data.horaire[0]) { setHoraireData(JSON.parse(response.data.horaire[0].WorkingTime)) } else { } 
            
             
            
            setLoading(true)

        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Esseyeé de connecter plus tard</div></>, GConf.TostInternetGonf) 
              setProfileData([])
              //setLoading(true)
            }
        });
    }, [])

    /*###############################[Function]################################# */
    const PrintFunction = (frameId) =>{usePrintFunction(frameId)}
    
    /*Genrale */
    const GetDelegList = (value) =>{
        setGeneralData({...generalData, Gouv: value })
        const found = TunMap.Deleg.filter(element => element.tag === value)
        setDelegList(found)
    }
    const UpdateGeneralDataFunc = () =>{
        if (!generalData.Name ) {toast.error("Nom de la ste est  Invalide !", GConf.TostErrorGonf)}
        else if (!generalData.Gouv ) {toast.error("Gouv est  Invalide !", GConf.TostErrorGonf)}
        else if (!generalData.Deleg ) {toast.error("Delegation est  Invalide !", GConf.TostErrorGonf)}
        else if (!generalData.Phone ) {toast.error("Phone est  Invalide !", GConf.TostErrorGonf)}
        else if (!generalData.Adress ) {toast.error("Adress est  Invalide !", GConf.TostErrorGonf)}
        else if (!generalData.Genre ) {toast.error("Genre est  Invalide !", GConf.TostErrorGonf)}
        else{
            setLS(true)
            axios.post(`${GConf.SharedApi}/profile/update/general`, {
                PID : GConf.PID,
                SystemTag : GConf.systemTag,
                profileDataSent : generalData,
            }).then(function (response) {
                console.log(response.data)
                if(response.data.affectedRows) {
                    toast.success("Profile Modifieé !", GConf.TostSuucessGonf)
                    setLS(false)
                }
                else{
                    toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                    setLS(false)
                }
            })                
        }
    }
    const onShare = async () => {
        if (navigator.share) {
        try {
            const result = await navigator.share({
            title: 'منصة أبيض ',
            text: 'جرب منصة abyedh.com' ,
            url: `https://abyedh.com/S/P/${GConf.systemTag}/${GConf.PID}`,
            });
            console.log('Successfully shared', result);
        } catch (error) {
            console.error('Error sharing:', error);
        }
        } else {
        alert('Sharing is not supported in this browser.');
        }
    };


    /* Rating */
    const CalculateRating = (table) =>{
        let tot = 0;
        table.map( data => {
            tot = tot + data.Rating
        })
        if (tot == 0) {
            return tot
        } else {
            return parseFloat(tot / table.length).toFixed(1)
        }
        
        //
    }
    const CalculateLikes = (table) =>{
        const WantedValue =  table.length ;
        if ( WantedValue / 1000 > 1 && WantedValue / 1000000 < 1) { return parseFloat(WantedValue / 1000 ).toFixed(1) + 'K' }
        else  if (WantedValue / 1000000 > 1) { return parseFloat(WantedValue / 1000000 ).toFixed(1) +'M' }
        else{ return parseInt(WantedValue)  }
    }
    const CalculateReview = (table, value ) =>{
        let filteredArray = table.filter(obj => parseInt(obj.Rating) == value );
        if (filteredArray != 0) {
            return(parseInt((filteredArray.length / table.length) * 100 ) )
        } else {
            return 0
        }
        
    }
    const ReturnAvatarGroupList = (list) =>{
        let FinalList = []

        list.map( (data,index) => FinalList.push({ key: index, name: data.Name , src: `https://cdn.abyedh.com/images/p_pic/${data.PictureId}.gif`},))
        return FinalList
    }

    /*Images */
    const onFileUpload = async (event) => {
        setLoadingState(true)
        let file = event.target.files[0]
        const clientId = "4c61b93ac10206d"; // Ensure this is your actual Client ID
        const auth = `Client-ID ${clientId}`;

        const formData = new FormData();
        formData.append("image", file);

        try {
            const response = await fetch("https://api.imgur.com/3/image", {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: auth,
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.success) {
                //alert("Image uploaded successfully");
                setProfilePhotoData({ PID: GConf.PID, ImageLink: data.data.link, Destination: data.data.deletehash })
                setImageLink(data.data.link)
                 
                setLoadingState(false)
            } else {
                setLoadingState(false)
                alert("Upload failed");
                console.log("Error details:", data);
                
            }
        } catch (err) {
            setLoadingState(false)
            alert("Failed to upload image");
            console.log("Error:", err);
        }
    };
    const SavePhotos = () =>{
         
        if (!imageLink.length) {toast.error(t('appPages.imagesPage.toast.one') , GConf.TostErrorGonf) }  
        else {
            axios.post(`https://api.abyedh.com/api/application/app/profile/images/ajouter`, {
                profilePhotoData: profilePhotoData
            })
            .then(response => toast.success(t('appPages.imagesPage.toast.three'), GConf.TostSuucessGonf))
            .catch(error => console.log(error));
        }
        
    }
    const DeleteImageFunc = async () => {
        const clientId = "4c61b93ac10206d"; // Ensure this is your actual Client ID
        const auth = `Client-ID ${clientId}`;

         
        try {
            const response = await fetch(`https://api.imgur.com/3/image/${toDeleteId}`, {
                method: "DELETE",
                headers: {
                    Authorization: auth, // Same auth token used for upload
                    Accept: "application/json",
                },
            });
        
            const data = await response.json();
        
            if (data.success) {
                axios.post(`https://api.abyedh.com/api/application/app/publications/delete`, {
                    toDeleteId: toDeleteId ,
                }).then(function (response) {
                    toast.success(<><div><h5>تم حذف  المنشور  بنجاح </h5>  </div></>, GConf.TostInternetGonf)
                    window.location.reload()
                })

            } else {
                alert("Delete failed");
                console.log("Error details:", data);
            }
        } catch (err) {
            alert("Failed to delete image");
            console.log("Error:", err);
        }
         
    }
    const OpenDeleteModal = (targetImage) => {
        setToDeleteID(targetImage)
        setOpenD(!openD)
    }

    /*Position */
    const GetPositionNow = () =>{
        //get position 
        navigator.geolocation.getCurrentPosition(
            function(position) {
                if (!position.coords.latitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lat</h5></div></>, GConf.TostInternetGonf)}
                else if (!position.coords.longitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lng</h5></div></>, GConf.TostInternetGonf)}
                else{
                    setMyPosition([position.coords.latitude, position.coords.longitude])
                }
            },
            function(error) {
                toast.error(<><div><h5>ENTRE VOTRE POSITION</h5></div></>, GConf.TostInternetGonf)
            }
        );
    }
    const CheckPositions = () =>{
        let LAT = myPosition[0] === parseFloat(generalData.Lat)
        let LNG = myPosition[1] === parseFloat(generalData.Lng)
        return (LAT && LNG)
    }
    const UpdatePositionFunc = () =>{
        if (!passwordData.Identification) {toast.error("Identifiant est Invalide !", GConf.TostErrorGonf)}
        else if (!passwordData.PasswordSalt ) {toast.error("Mot de passe est  Invalide !", GConf.TostErrorGonf)}
        else{
            setLS(true)
            axios.post(`${GConf.SharedApi}/profile/update/position`, {
                PID : GConf.PID,
                positionDataSent : myPosition,
                SystemTag : GConf.systemTag
            }).then(function (response) {
                if(response.data.affectedRows) {
                    toast.success("Position Modifieé !", GConf.TostSuucessGonf)
                    setLS(false)
                }
                else{
                    toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                    setLS(false)
                }
            })                
        }
    }
    const handleLocationSelected = (location) => {
        setPosition({Lat: location.lat , Lng:location.lng})
        setMyPosition({Lat: location.lat , Lng:location.lng})
    }
    const GetMyLocation = () =>{
        navigator.geolocation.getCurrentPosition(
            function(position) {
                if (!position.coords.latitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lat</h5></div></>, GConf.TostInternetGonf)}
                else if (!position.coords.longitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lng</h5></div></>, GConf.TostInternetGonf)}
                else{
                    setPosition({Lat:position.coords.latitude, Lng:position.coords.longitude})
                    setMyPosition({Lat:position.coords.latitude, Lng:position.coords.longitude})
                }
            },
            function(error) {
                toast.error(<><div><h5>ENTRE VOTRE POSITION</h5></div></>, GConf.TostInternetGonf)
            }
        );
    }

    /*Horiare */
    const SetTimmingData = (day,time,genre,value) => {
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming

        if (time == 'matin') {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].matin.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].matin.end = value
                setTimming(copyOfHoraire)
            }
        } else {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].soir.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].soir.end = value
                setTimming(copyOfHoraire)
            }
        }

    }
    const UpdateTimmingData = (day,time,genre,value) => {
        //setTimming(...timming)
        setTest(Math.random())
        toast.success("", GConf.TostAddedToTimming)

    }  
    const setPauseDay = (day,state) =>{
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming
        copyOfHoraire[targetIndex].dayOff = !state
        setTimming(copyOfHoraire)
        setTest(Math.random())
    }

    /*###############################[Card]################################# */
    const PrintProfile = () =>{ 
        return(<>
            <div className="row">
                <div className="col-12 col-lg-4 text-center mb-3 ">
                    <QRCode value={GConf.PID} size={130} />
                    <h1 className='text-center text-secondary '> {GConf.PID} </h1>
                           هذا المعرف سوف يميزك عن بقية المسجلين على المنصة. يمكن أن تكون هذه أيضًا طريقة قصيرة للإعلان لك

                    <div>
                    <Button size='mini' fluid className='rounded-pill' onClick={() => navigator.clipboard.writeText(localStorage.getItem('PID'))}><Icon name='copy'  />  نسخ  PID </Button>
                    </div>
                </div>
                <div className="col-12 col-lg-8 align-self-center" dir='rtl'>

                         <h5   className='text-danger'> <span className='bi bi-exclamation-octagon-fill'></span> يمكن أن تستعمل إحدي الطرق التالية للتعريف بملفك الخاص : </h5>
                        <div >
                            1- قم بمشاركة ملفك علي شبكات التواصل الإجتماعي من خلال الزر التالي  <br /> 
                            {/* <Button size='mini' className='mt-2 rounded-pill' fluid  primary target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=https://abyedh.tn/S/P/${APPConf.systemTag}/${APPConf.PID}&picture=https://en.wikipedia.org/wiki/QR_code#/media/File:QR_code_for_mobile_English_Wikipedia.svg`} >  <Icon name='facebook f' /> إعلان علي الفايسبوك  </Button> */}
                            <Button className='mt-2 rounded-pill text-white' fluid  style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}}   onClick={() => onShare()}  >  <Icon name='share alternate' />   نشر الملف  </Button>
                        </div>
                        <div  className='mt-4'>
                           2- قم بطباعة هذا المنشور و إلصاقة علي مكتب أو محل العمل من أجل تسهيل وصول العملاء لملفك عن طريق مسح الكود الخاص بك بهواتفهم  <br />
                            <Button className='mt-2 rounded-pill' fluid positive style={{background: 'linear-gradient(to right, #fcba03, #fc7703)'}} onClick={(e) => PrintFunction('printPID')}> <Icon name='print'  />  طباعة المنشور </Button>
                        </div>

                        {/* هذا المعرف سوف يميزك عن بقية المسجلين على المنصة. يمكن أن تكون هذه أيضًا طريقة قصيرة للإعلان لك
                        <div>
                        <Button size='mini' className='rounded-pill' onClick={() => navigator.clipboard.writeText(localStorage.getItem('PID'))}><Icon name='copy'  />  نسخ  PID</Button>
                        </div>
                        <br /> 
                        اطبع هذا الرابط الذي يمكن تعليقه على باب متجرك حتى يتمكن عملاؤك من الوصول إليك بسهولة، كما يمكن مشاركته مباشرة على وسائل التواصل الاجتماعي
                        <div className='mt-2'>
                        <Button  className='rounded-pill' fluid  positive onClick={(e) => PrintFunction('printPID')}> <Icon name='print'  />  طباعة </Button>
                        <Button className='mt-2 rounded-pill' fluid     onClick={() => onShare()}  >  <Icon name='share alternate' />  نشر الملف </Button>
                        </div> */}

                        
                </div>
            </div>
            {/* <Divider /> */}
            <div className="d-flex d-none">
                <div className="flex-shrink-0">
                {/* <QRCode value={`${GConf.systemTag}/${GConf.PID}`} size={130} /> */}
                </div>
                <div className="flex-grow-1 ms-3">
                    Imprimez ce lien qui peut être accroché à la porte de votre magasin afin que vos clients puissent vous joindre facilement, et il peut également être partagé directement sur les réseaux sociaux
                    <div className='mt-2'>
                        <Button size='mini' positive onClick={(e) => PrintFunction('printPID')}> <Icon name='print'  />Imprimer</Button>
                        <Button size='mini' primary target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=https://abyedh.com/S/P/${GConf.systemTag}/${GConf.PID}`} >  <Icon name='facebook f' /> Partager </Button>
                    </div>
                </div>
            </div>
        </>)
    }
    const ProfileCard = () =>{
        return(<>
            <div className="card card-body shadow-sm mb-4 sticky-top border-div d-none" style={{top:'70px'}}>
	            <div className="text-center ">
	            	<img className="rounded-circle mb-3" src={`https://cdn.abyedh.com/images/ads/${GConf.systemTag}.svg`} width="90px" height="90px"/>
	            
	            	 <h6>{loading ? profileData.general[0].Name : SKLT.BarreSkl } </h6>
	            	<div><small className="text-secondary">   ({loading ? profileData.general[0].Genre : SKLT.BarreSkl })</small></div>
	            	<div><small className="text-secondary"><span className="bi bi-geo-alt"></span> {loading ? <> {profileData.general[0].Adress} , {profileData.general[0].Gouv} </> : SKLT.BarreSkl } </small></div>
	            	<div><small className="text-secondary"><span className="bi bi-telephone"></span> +216 {loading ? profileData.general[0].Phone : SKLT.BarreSkl } </small></div> 
                    <h5>PID : {localStorage.getItem('PID')} <Button size='mini' icon='copy' className='rounded-circle' onClick={() => navigator.clipboard.writeText(localStorage.getItem('PID'))}></Button> </h5>
					<Divider /> 
					<div className='row mt-2'>
						<div className='col-6'>
						    <Statistic color='red' size='small'>
								<Statistic.Value>
                                {loading ? CalculateRating(profileData.review) : SKLT.BarreSkl }
								</Statistic.Value>
								<Statistic.Label>{t('communUsed.profilePage.numAvis')}</Statistic.Label>
							</Statistic>
						</div>
						<div className='col-6'>
							<Statistic color='red' size='small'>
								<Statistic.Value>
                                 {loading ? CalculateLikes(profileData.likes) : SKLT.BarreSkl }
								</Statistic.Value>
								<Statistic.Label>{t('communUsed.profilePage.numLikes')}</Statistic.Label>
							</Statistic>
						</div>
					</div>
					<Divider />
					<div className='row'>
                        <div className='col-3'>
							<Icon circular inverted color='secondary'  name='try' /> TikTok
						</div>
                        <div className='col-3'>
							<Icon circular inverted color='pink'  name='instagram' /> insta
						</div>
						<div className='col-3'>
							<Icon circular inverted color='red'  name='youtube' />youtube
						</div>
						<div className='col-3'>
							<Icon circular inverted color='blue'  name='facebook square' /> facebook
						</div>
						
						
					</div>
					<br />
					<br />
					<div className='d-grid gap-2'>
						<a className='btn btn-danger btn btn-lg bnt-block rounded-pill text-white ' target="_blank" href={`https://abyedh.com/S/P/${GConf.systemTag}/${GConf.PID}`}>
							<span className='bi bi-person-circle me-3'></span>    
                            {t('communUsed.profilePage.profileLinkBtn')} 
						</a>
					</div>
	            </div>
            </div>
            <div className="card card-body shadow-sm mb-4 border-div">
                <div className='row'>
                    <div className='col-12 col-lg-3 align-self-center border-end text-center' >
                        {/* <img className="rounded-circle mb-2" src={`https://cdn.abyedh.com/images/ads/${GConf.systemTag}.svg`} width="90px" height="90px"/> */}
                         <div style={{ position: 'relative', display: 'inline-block' }} onClick={() => setProfilePicModal(!profilePicModal)}>
                                <img
                                    className="rounded-circle mb-3 border border-3   cursor-pointer"
                                    src={
                                    loading && profileData.general[0].ProfilePhoto
                                        ? `https://cdn.abyedh.com/images/Directory/${profileData.general[0].ProfilePhoto}`
                                        : `https://cdn.abyedh.com/images/ads/${GConf.systemTag}.svg`
                                    }
                                    width="90"
                                    height="90"
                                    alt="Profile"
                                />

                                 
                                 <Button 
                                    icon
                                    size="small"
                                    style={{
                                        position: 'absolute',
                                        bottom: 20,
                                        right: 3,
                                        background: 'whhite',
                                        borderRadius: '50%',
                                        padding: '2px',
                                        color : '#5c5b57',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Icon  name='upload' />
                                </Button>
                                </div>
	                     <h3 className='mt-1'>{loading ? profileData.general[0].Name : SKLT.BarreSkl } </h3>
                    </div>
                    <div className='col-12 col-lg-5 align-self-center border-end'>
                        <div className='text-secondary'> <span className="bi bi-star"></span> :   {loading ? profileData.general[0].Genre : SKLT.BarreSkl } </div>
                        <div className='text-secondary'><span className="bi bi-geo-alt"></span> : {loading ? <> {profileData.general[0].Adress} , {profileData.general[0].Gouv} </> : SKLT.BarreSkl } </div>
                        <div className='text-secondary'><span className="bi bi-telephone"></span> :  +216 {loading ? profileData.general[0].Phone : SKLT.BarreSkl } </div> 
                        <Button color="teal" size='tiny' className='mt-3' fluid circular as="a" href={`Parametre/confirmation`}  icon="check circle" content="Confirmer" />

                        
                    </div>
                    <div className='col-12 col-lg-2 align-self-center border-end'>
                        <div className='row mb-3'>
                            <div className='col-6'>
                                <Statistic color='red' size='small'>
                                    <Statistic.Value>
                                    {loading ? CalculateRating(profileData.review) : SKLT.BarreSkl }
                                    </Statistic.Value>
                                    <Statistic.Label>{t('communUsed.profilePage.numAvis')}</Statistic.Label>
                                </Statistic>
                            </div>
                            <div className='col-6'>
                                <Statistic color='red' size='small'>
                                    <Statistic.Value>
                                    {loading ? CalculateLikes(profileData.likes) : SKLT.BarreSkl }
                                    </Statistic.Value>
                                    <Statistic.Label>{t('communUsed.profilePage.numLikes')}</Statistic.Label>
                                </Statistic>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-3'>
							<Icon circular inverted color='secondary'  name='try' />  
						</div>
                        <div className='col-3'>
							<Icon circular inverted color='pink'  name='instagram' />  
						</div>
						<div className='col-3'>
							<Icon circular inverted color='red'  name='youtube' /> 
						</div>
						<div className='col-3'>
							<Icon circular inverted color='blue'  name='facebook square' />  
						</div>
                        </div>
                    </div>
                    <div className='col-12 col-lg-2 align-self-center'>
                       <Button color="red" fluid circular as="a" href={`https://abyedh.com/S/P/${GConf.systemTag}/${GConf.PID}`} target="_blank" icon="user circle outline" content={`Voir ${t('communUsed.profilePage.profileLinkBtn')}`} />
                       <br />
                       <Button fluid circular  onClick={() => navigator.clipboard.writeText(localStorage.getItem('PID'))}  icon='copy' content={localStorage.getItem('PID')} />
 
                        {/* <a className='btn btn-danger btn btn-lg bnt-block rounded-pill text-white ' target="_blank" href={`https://abyedh.com/S/P/${GConf.systemTag}/${GConf.PID}`}>
							<span className='bi bi-person-circle  '></span>    
                            {t('communUsed.profilePage.profileLinkBtn')} 
						</a> */}
                    </div>
                </div>
            </div>
        </>)
    }
    
    const RatingProfile = () =>{
        const RatingBar = (props) => {
            return (<>
                <div className="row">
                    <div className="col-2"><h3>{props.name}</h3></div>
                    <div className="col-8 align-self-center">
                        <div className="progress" style={{height: "5px"}}>
                            <div className="progress-bar bg-warning" role="progressbar" style={{width: `${props.value}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div> 
                    </div>
                    <div className="col-2"><h6>{props.value} %</h6></div>
                </div>
            </>)
        }
        return (<>
            {/* <div className='card card-body shadow-sm border-div mb-2 text-center'> */}
                <h5 className='text-start'>Avis</h5>
                <div className='row text-center'>
                    <div className='col-4 align-self-center'>
                        <h1 className='text-warning'>{loading ? <> {CalculateRating(profileData.review)}</>: 0 }</h1>
                        <Rating className='d-inline' maxRating={5} defaultRating={loading ? CalculateRating(profileData.review) : 0 } icon='star' disabled size='massive' />
                        <h6 className="pt-2">{loading ? profileData.review.length : 0 } </h6>
                    </div>
                    <div className='col-8'>
                        <RatingBar name={1} value={loading ? CalculateReview(profileData.review, 1) : 0 } />
                        <RatingBar name={2} value={loading ? CalculateReview(profileData.review, 2) : 0 } />
                        <RatingBar name={3} value={loading ? CalculateReview(profileData.review, 3) : 0 } />
                        <RatingBar name={4} value={loading ? CalculateReview(profileData.review, 4) : 0 } />
                        <RatingBar name={5} value={loading ? CalculateReview(profileData.review, 5) : 0 } />
                    </div>
                </div> 
                <hr />
                <h5>J'aimes</h5>
                {/* <div style={{height:'200px', overflowX:'auto', overflowX:'hidden'}}> */}
                        {/* <h2 className='text-center'>{profileData.likes ? profileData.likes.length : '...'}</h2>  */}
                        <AvatarGroup className='text-center' size="large" maxCount={12} data={ReturnAvatarGroupList(profileData.likes)}   borderColor="#cfcecc" />
                        {/* { loading ?
                        
                            profileData.likes.map( (data,index) => <a href='https://www.abyedh.com' key={index}>{data.Name}</a>)

                        : 'fa'
                        } */}
                        
                {/* </div>                */}
            {/* </div> */}
        </>)
    }
    const CommentsProfile = () =>{

        const CommentsCard = (props) => {
            return (<>
                    <div className="d-flex mb-2 border-bottom">
                        <div className="flex-shrink-0">
                            <img src={`https://cdn.abyedh.com/images/p_pic/${props.data.PictureId}.gif`} className='rounded-circle' width='30px' alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3 w-100">
                            <div className='row  mb-0'>
                               <div className='col-6 text-start'>{props.data.Name}</div>
                               <div className='col-6 text-end'><small className='text-secondary'> {new Date (props.data.R_Date).toLocaleDateString()}</small></div>
                            </div>
                            <div><b>{props.data.Comment} </b></div>
                        </div>
                    </div>
            </>)
        }

        return(<>
        
                <div className='row '>
                    <div className='col-12 pe-1'>
                            <h5>Commentaires</h5> 
                            <div style={{height:'200px', overflowX:'auto', overflowX:'hidden'}}>
                                { loading ?
                                    <Comment.Group>
                                    { profileData.review.map( (data,index) =>  <CommentsCard key={index} data={data} /> )}
                                    </Comment.Group>
                                    : '...'
                                }    
                            </div>  
                    </div>
                </div>
        </>)
    }
    const DayHoraire = (props) =>{
        return(<>
                <div className='row'>
                    <div  className='col-1 align-self-center'>
                        <b>{props.data.day}</b>
                    </div>
                    <div  className='col-5'>
                        <div className='row'>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={JSON.parse(props.data.dayOff)}  fluid className='mb-1' value={props.data.matin.start}/></div>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={JSON.parse(props.data.dayOff)}  fluid className='mb-1' value={props.data.matin.end}/></div>
                        </div>
                    </div>
                    <div  className='col-5'>
                        <div className='row'>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={JSON.parse(props.data.dayOff)}  fluid className='mb-1' value={props.data.soir.start}/></div>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={JSON.parse(props.data.dayOff)}  fluid className='mb-1' value={props.data.soir.end}/></div>
                        </div>
                    </div>
                    <div  className='col-1 align-self-center'>
                        <div className="form-check form-switch">
                            <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setAlwaysState(!props.data.dayOff)}  checked={JSON.parse(props.data.dayOff)} />
                        </div>
                    </div>
                </div>
        </>)
    }
    const InputHoraireCard = () =>{
        return(<>
            <div className='card-body '>
                <div className='row'>
                    <div className='col-12 col-lg-11 align-self-center'> 
                        <h5 className='mb-0'>Toujour Overt</h5>  
                        <small>Coucher pour apraitre que vous étes toujour ouvert </small>
                    </div>
                    <div className='col-12 col-lg-1 align-self-center'> 
                        <div className="form-check form-switch">
                            <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setAlwaysState(!alwaysState)}  checked={alwaysState} />
                        </div>
                    </div>
                </div>
                <Divider />
                <div className='row text-danger mb-2'>
                    <div  className='col-1'> <b>Jour</b> </div>
                    <div  className='col-5'> <small>Matin</small> </div>
                    <div  className='col-5'> <small>Soir</small> </div>
                    <div  className='col-1'> <small>Repos</small> </div>
                </div>
                
                {
                    horaireData.map( (data,index) => <DayHoraire key={index} data={data}/>)
                }
                {/* <DayHoraire />
                <DayHoraire />
                <DayHoraire />
                <DayHoraire />
                <DayHoraire />
                <DayHoraire /> */}

                <div className='row mb-2 mt-4'>
                        <div className='col-8'> </div>
                        <div className='col-4 text-end'> 
                                <Button  className='rounded-pill bg-system-btn' size='mini' ><Icon name='save' /> Modifier Horaire <Loader inverted  inline size='tiny' className='ms-2'/></Button>
                        </div>
                    </div>
            </div>
            </>)
    }
    const AcutelCalendarCard = () =>{
        return(<>
        <FullCalendar 
            plugins={[ timeGridPlugin ]}
            initialView="timeGridWeek"
            locale='fr' 
            dayHeaderFormat = {{weekday: 'short'}}
            events={[
                { title: 'S1',  start: '2022-08-18T08:00:00' , end: "2022-08-18T12:00:00", display: 'background', backgroundColor:'red'},
                { title: 'S2', start: '2022-08-18T14:00:00', end: "2022-08-18T18:00:00", display: 'background' },
                { title: 'S1',  start: '2022-08-18T08:00:00' , end: "2022-08-18T12:00:00", display: 'background'},
                { title: 'S2',  start: '2022-08-18T14:00:00' , end: "2022-08-18T18:00:00", display: 'background'},
            ]}
            headerToolbar='false'
            height='350px'
            allDaySlot= {false}
        />
        </>)
    }  
    const DeconnextionCard = () => {
        const LogOut = () =>{
            localStorage.removeItem(`PID`);
            window.location.href = "/login";
        }

        return(<>
         
                    <h3 className='text-secondary'> <span className='bi bi-box-arrow-right'></span> Déconnexion : </h3>
                    <p>Êtes-vous sûr de vouloir quitter ?</p>
                    <Button fluid className='text-white rounded-pill' style={{background: 'linear-gradient(to right, #918d8d, #1c1717)'}} onClick={() => LogOut()}> <span className='bi bi-box-arrow-left'></span> Déconnexion </Button>
               
        </>)
    }


    return (<>
        <Bounce bottom>
            <h5><span className="bi bi-person-circle"></span> {t('communUsed.profilePage.mainTitle')} </h5>
            
            {!loading ? 'loading' : 
            <div className="row justify-content-center">
                    <div className="col-12  ">
                        <ProfileCard /> 
                         
                    </div>
                    <div className="col-12 col-lg-9  ">
                        <Tab menu={{ secondary: true, pointing: true ,className: "wrapped"}} panes={panes} />
                    </div>
            </div>
            }
        </Bounce>
        <FrameForPrint frameId='printPID' src={`/Pr/ProfilePrint/pid`} />
        <BottomSheet className="custom-bottom-sheet" expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
            <div className='card-body mb-4'>
                            <h5> <span className='bi bi-exclamation-triangle-fill text-danger bi-md'></span> Voulez Vous supprimer cette Image ?  </h5>
                            <Button className='btn bg-danger rounded-pill text-white' fluid onClick={() => DeleteImageFunc()} > <span className='bi bi-trash '></span> Oui</Button>           
                </div>
        </BottomSheet>
        <BottomSheet style={{ '--rsbs-max-w': '50vw',  '--rsbs-ml': 'auto', '--rsbs-mr': 'auto' }} expandOnContentDrag open={profilePicModal}  onDismiss={() => setProfilePicModal(!profilePicModal)}  >
            <div className='card-body'><ProfilePictureCard /></div>
        </BottomSheet>
    </>);
}

export default ProfilePage;